import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import resultPage from '../views/resultPage.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/resultPage',
    name: 'resultPage',
    component: resultPage
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
